const typography = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ACTIVE_CAPS: "ACTIVE",
  INACTIVE_CAPS: "INACTIVE",
  ALL: "All",
  FREE: "Free",
  PREMIUM: "Premium",
  NAME: "Name",
  EMAIL: "Email",
  PHONE: "Phone",
  PLAN: "Plan",
  AGE: "Age",
  DATE_OF_BIRTH: "Date of Birth",
  STATUS: "Status",
  ACTION: "Action",
  OCCUPATION: "Occupation",
  GENDER: "Gender",
  MEMBERSHIP_PLAN: "Membership Plan",
  CUSTOMER_DETAILS: "Customer Details",
  AFFIRMATION_DETAILS: "Affirmation Details",
  DATE: "Date",
  CATEGORY: "Category",
  BLS_DURATION: "BLS Duration",
  FEEDBACK: "Feedback",
  STATUS_UPDATE_CONFIRMATION_MESSAGE:
    "Are you sure you want to update user status?",
  YES: "Yes",
  NO: "No",
  CUSTOMER: "CUSTOMER",
  USER: "USER",
  ADVANCED_FILTERS: "advanced filters",
  METRIC_TYPE: "Metric Type",
  ENGAGED_USERS: "Engaged Users",
  DELETED_USERS: "Deleted Users",
  IDLE_USERS: "Idle Users",
  SIGNUPS: "Signups",
  DATE_RANGE: "Date Range",
  EXPORT_CSV: "Export CSV",
  VERIFICATION: "Verification",
  VERIFIED: "Verified",
  NOT_VERIFIED: "Non Verified",

  // Customer Details activity tabs
  TABS_OVERVIEW: "Overview",
  TABS_RESETS: "Resets",
  TABS_PLAN_PAYMENTS: "Plan & Payments",
  TABS_AFFIRMATIONS: "Affirmations",
  TABS_MOOD: "Mood",
  TABS_BLS_SESSIONS: "BLS Sessions",
  TABS_WELLNESS_TESTS: "Wellness Tests",

  MOOD_HISTORY: "Mood History",
  NO_MOOD_ENTRIES: "No mood entries yet",
  MOOD_TYPE: "Mood",
  DESCRIPTION: "Description",

  BLS_SESSIONS: "BLS Sessions",
  NO_BLS_SESSIONS: "No BLS sessions yet",
  QUICK_RESET: "Quick Reset",
  SUBMITTED: "Submitted",
  NOT_SUBMITTED: "Not Submitted",
  RATING: "Rating",

  WELLNESS_TESTS: "Wellness Tests",
  NO_WELLNESS_TESTS: "No wellness test attempts yet",
  TEST_NAME: "Test",
  SCORE: "Score",
  SEVERITY: "Severity",
};

export default typography;
